import initialStates from '../../initialStates';
import {
    FETCH_STOCK_WAREHOUSE,
    FETCH_STOCK_WAREHOUSE_FAILURE, FETCH_STOCK_WAREHOUSE_SUCCESS,
} from './stockWarehouse-actions';

const stockWarehouseReducer = (state = initialStates.stockWareHouse, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_STOCK_WAREHOUSE:
        newState = { ...state, isLoading: true };
        break;
    case FETCH_STOCK_WAREHOUSE_SUCCESS:
        newState = {
            ...state,
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
            filters: action.filters,
        };
        break;
    case FETCH_STOCK_WAREHOUSE_FAILURE:
        newState = { ...state, isLoading: false };
        break;

    default:
        newState = state;
    }
    return newState;
};

export default stockWarehouseReducer;
